import React from 'react';
import { Loader } from '../../../resources/images/icons';
import HtmlDynamically from '../subcomponents/htmlDynamically';

const MaskLoader = () => (
  <div className='loader-container'>
    <div className='loadingDiv'>
      <HtmlDynamically html={Loader}/>
    </div>
  </div>
);

export default MaskLoader;
